let nextId = 0;

/** Unikátní `id` pro prvek stránky (např. vazba `label for` ↔ `input id`). Nahrazuje `uuid` – stačí čítač s prefixem. */
export function uniqueId(): string {
  return `reza-${nextId++}`;
}
